// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32lt0","top":"styles_top__TAGNz"};